import ApexCharts from 'apexcharts';
import axios from 'lib/axios';

const formatCount = (value) => Math.round(value).toLocaleString('nl-NL');
const formatEuro = (value) => `€ ${Math.round(value).toLocaleString('nl-NL')}`;

const buildSeries = (series, line) => {
  const bars = series.map(({ name, data }) => ({ name, type: 'column', data }));

  return line ? [...bars, { name: line.name, type: 'line', data: line.data }] : bars;
};

const buildColors = (series, line) => {
  const colors = series.map(({ color }) => color);

  return line ? [...colors, line.color] : colors;
};

const buildYaxis = (series, line) => {
  const countAxis = { labels: { formatter: formatCount }, forceNiceScale: true };

  if (!line) return countAxis;

  // Bind every stacked bar series to the count axis explicitly (seriesName as an
  // array) and the revenue line to its own euro axis. An unbound/empty count
  // axis makes ApexCharts crash when bars and a line share the chart.
  return [
    { ...countAxis, seriesName: series.map(({ name }) => name) },
    { seriesName: line.name, opposite: true, labels: { formatter: formatEuro }, forceNiceScale: true }
  ];
};

export const chartOptions = (labels, series, line, height = 300) => ({
  series: buildSeries(series, line),
  colors: buildColors(series, line),
  chart: {
    height,
    type: line ? 'line' : 'bar',
    stacked: true,
    zoom: { enabled: false },
    toolbar: { show: false }
  },
  plotOptions: { bar: { columnWidth: '70%' } },
  stroke: { width: line ? [...series.map(() => 0), 3] : 0, curve: 'smooth' },
  dataLabels: { enabled: false },
  legend: { position: 'top' },
  xaxis: { categories: labels },
  yaxis: buildYaxis(series, line),
  tooltip: {
    shared: true,
    intersect: false,
    y: {
      formatter(value, { seriesIndex, w }) {
        const seriesName = w.config.series[seriesIndex].name;

        return line && seriesName === line.name ? formatEuro(value) : formatCount(value);
      }
    }
  },
  grid: { borderColor: '#f1f3fa' }
});

document.addEventListener('DOMContentLoaded', () => {
  const chartElement = document.getElementById('chart-stacked-bar');

  if (chartElement) {
    const labels = JSON.parse(chartElement.dataset.labels);
    const series = JSON.parse(chartElement.dataset.series);
    const line = JSON.parse(chartElement.dataset.line);
    const height = parseInt(chartElement.dataset.height, 10) || 300;

    const chart = new ApexCharts(chartElement, chartOptions(labels, series, line, height));
    chart.render();

    let year = parseInt(chartElement.dataset.year, 10);
    const titleElement = document.getElementById('chart-stacked-bar-title');

    const browse = (step) => {
      axios.get(chartElement.dataset.url, { params: { year: year + step } }).then(({ data }) => {
        year = data.year;
        titleElement.textContent = data.title;
        chart.updateOptions({ series: buildSeries(data.series, line), xaxis: { categories: data.labels } });
      });
    };

    const previousButton = document.getElementById('chart-stacked-bar-previous');
    const nextButton = document.getElementById('chart-stacked-bar-next');

    if (previousButton) previousButton.addEventListener('click', () => browse(-1));
    if (nextButton) nextButton.addEventListener('click', () => browse(1));
  }
});
